/**
 * Gera um código opaco curto (10 chars, base36 maiúscula) para usar como
 * identificador único de link público de imóvel.
 *
 * Combina timestamp ms (sortável, ~8 chars) + 2 chars random. Probabilidade
 * de colisão no MVP é desprezível; em produção o backend deve garantir
 * unicidade global com índice unique no banco.
 */
export function generateShareCode(): string {
  const time = Date.now().toString(36); // ~8 chars
  const rand = Math.random().toString(36).slice(2, 4);
  return (time + rand).slice(-10).toUpperCase();
}

export function isValidShareCode(value: string): boolean {
  return /^[A-Z0-9]{6,16}$/.test(value);
}
